import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "TimerToast",
  class: "timer-toast"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TimerToast',
  setup(__props) {


/********************************************************************************
 * タイマートースト
 *
 * @since 2023/06/05
 * @author 松本裕介
 *
 *********************************************************************************/


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})